import PropTypes from 'prop-types'

export const displayCurrencyPropType = PropTypes.shape(
{
  code: PropTypes.string.isRequired,
  rate: PropTypes.number.isRequired
})

